const IntroductionContent = () => {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-3xl font-semibold text-blue-800 mb-6">Introduction</h1>
        <p>
          Securweave’s Host Intrusion Detection System (HIDS) is a security
          mechanism designed to monitor and analyse the activities within
          individual hosts or devices to detect suspicious behaviour,
          unauthorized access, or malicious intrusions. Unlike network-based
          intrusion detection systems (NIDS), which monitor entire networks,
          HIDS focuses on individual systems, making it particularly effective
          at detecting threats that may bypass network defences, such as file
          integrity changes, rootkit installations, or specific host-based
          anomalies.
        </p>
        <p>
          HIDS protects critical assets by identifying potential threats in
          real-time, providing early warnings of attacks, and allowing for
          immediate mitigation actions. It works by analysing logs, monitoring
          system calls, and comparing system states against a predefined
          baseline, alerting administrators when deviations or threats are
          detected.
        </p>
        <p>
          HIDS’ dashboard serves as a control centre for monitoring these
          activities, giving administrators a clear overview of system status,
          alerts, and events. The dashboard offers real-time data visualization
          through charts, graphs, and logs, making it easier to identify,
          prioritize, and respond to threats. With features such as intrusion
          detection, file integrity monitoring, and event management, HIDS
          ensures that systems are continuously safeguarded against potential
          attacks and data breaches.
        </p>
        <p>
          Securweave’s HIDS dashboard offers effective security management,
          visibility into the health and security of individual systems,
          enabling swift detection and response to any intrusion or abnormal
          activity.
        </p>

        <b> HIDS Works</b>
        <p>
          {" "}
          HIDS operates by analysing system logs, monitoring file integrity,
          tracking running processes, and detecting unauthorized modifications.
          It collects data from the host and compares it against predefined
          security rules to identify potential threats. If an anomaly is
          detected, the system generates alerts for further investigation.
        </p>

        <b>Key Features of HIDS</b>
        <ol className=" flex flex-col gap-4">
          <li>
            <b>Log Monitoring:</b> Continuously scans system logs to identify
            suspicious activities.
          </li>
          <li>
            <b> File Integrity Checking:</b> Detects unauthorized modifications
            to critical files.
          </li>
          <li>
            <b>Process Tracking:</b> Observes running applications and alerts on
            abnormal behaviour.
          </li>
          <li>
            <b>User Activity Analysis:</b> Monitors login attempts and privilege
            escalations.
          </li>
          <li>
            <b>Rootkit Detection:</b> Identifies malware that attempts to
            conceal its presence.
          </li>
          <li>
            <b>Configuration Auditing:</b> Ensures compliance with security
            policies.
          </li>
        </ol>
      </div>
    );
  };

  export default IntroductionContent;